import React from 'react';
const highlights = ['First sub-micron machines with Y-axis and B-Axis in the market', 'Microturning in sub-µm-range', 'Hardturning > 60 HRC to replace grinding operations', 'High accuracy process reliability', 'Small batches in toolroom-applications and prototyping', 'Mass-production with automation — most compact machines in terms of floor-space', 'Wide range of standardized auto-loading available by robots or special made solutions according to customers workpieces'];
const mechanicalEngineering = ['0.1 µm resolution linear scales integrated into slides', 'Slides positioning repeatability less than 0.4 µm', 'Special optimized ball-screws and guideways', 'Ultra precision spindle bearings', 'Most precise spindles for roundness of turned surfaces down to 0.1 µm'];
export function SpecsSection() {
  return <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-3919">
      <div data-id="element-3920">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3921">Highlights</h2>
        <ul className="space-y-3" data-id="element-3922">
          {highlights.map((item, index) => <li key={index} className="flex items-start" data-id="element-3923">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3924">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3925">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
      <div data-id="element-3926">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3927">
          Mechanical Engineering
        </h2>
        <ul className="space-y-3" data-id="element-3928">
          {mechanicalEngineering.map((item, index) => <li key={index} className="flex items-start" data-id="element-3929">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3930">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3931">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}